import * as AuthConstants from '../constants/user-constants'
import * as EventsConstants from '../constants/events-constants'
import * as TickersConstants from '../constants/tickers-constants'
import * as AdminConstants from '../constants/admin-constants'

const initialState = {
    showLoading: false
}

export const loadingReducer = (state = initialState, { type }) => {
    switch (type) {

    /** User */ 
    case AuthConstants.APP_SIGNUP_REQUEST:
    case AuthConstants.CHANGE_PASS_REQUEST:
    case AuthConstants.LOGIN_REQUEST:
    case AuthConstants.LOGOUT_REQUEST:
    case AuthConstants.SOCIAL_LOGIN_REQUEST:
    case AuthConstants.RECOVER_PASS_REQUEST:
    case AuthConstants.RECOVER_PASS_VERIFY_LINK_REQUEST:
    case AuthConstants.GET_BADGE_COLOR_REQUEST:
    case AuthConstants.PUT_BADGE_COLOR_REQUEST:
    case AuthConstants.CHANGE_LIVELI_PASS_REQUEST:
    case EventsConstants.CREATE_EVENT_BEGIN:     /** Events */
    case EventsConstants.DELETE_EVENT_BEGIN:
    case EventsConstants.FETCH_FORECASTS_BEGIN:
    case TickersConstants.CREATE_TICKER_BEGIN:      /**Tickes */
    case TickersConstants.GET_TICKER_BEGIN:
    case EventsConstants.RENDER_BEGIN:
    case AdminConstants.FETCH_REPORT_BEGIN:          /** Admin */
        return {
            showLoading: true
        }

    case EventsConstants.FETCH_ALL_EVENTS_BEGIN:  
    case EventsConstants.FETCH_RECURRENT_EVENTS_BEGIN:
        return{
            showLoading : localStorage.getItem('menu' ) === 'calendar' ?  true : false
        }
    /** User */ 
    case AuthConstants.CLEAR_USER_STATE:
    case AuthConstants.APP_SIGNUP_SUCCESS:    
    case AuthConstants.APP_SIGNUP_FAILURE:
    case AuthConstants.CHANGE_PASS_SUCCESS:
    case AuthConstants.CHANGE_PASS_FAILURE:
    case AuthConstants.LOGIN_SUCCESS:
    case AuthConstants.LOGIN_FAILURE:
    case AuthConstants.LOGOUT_SUCCESS:
    case AuthConstants.LOGOUT_FAILURE:
    case AuthConstants.SOCIAL_LOGIN_SUCCESS:
    case AuthConstants.SOCIAL_LOGIN_FAILURE:
    case AuthConstants.RECOVER_PASS_SUCCESS:
    case AuthConstants.RECOVER_PASS_FAILURE:
    case AuthConstants.RECOVER_PASS_VERIFY_LINK_SUCCESS:
    case AuthConstants.RECOVER_PASS_VERIFY_LINK_FAILURE:
    case AuthConstants.PUT_BADGE_COLOR_SUCCESS:
    case AuthConstants.PUT_BADGE_COLOR_FAILURE:
    case AuthConstants.GET_BADGE_COLOR_SUCCESS:
    case AuthConstants.GET_BADGE_COLOR_FAILURE:
    case AuthConstants.CHANGE_LIVELI_PASS_SUCCESS:
    case AuthConstants.CHANGE_LIVELI_PASS_FAILURE:
    case EventsConstants.FETCH_ALL_EVENTS_SUCCESS: /** Events */
    case EventsConstants.FETCH_ALL_EVENTS_FAILURE:
    case EventsConstants.CREATE_EVENT_FAILURE:
    case EventsConstants.CREATE_EVENT_SUCCESS:
    case EventsConstants.DELETE_EVENT_FAILURE:
    case EventsConstants.DELETE_EVENT_SUCCESS:
    case EventsConstants.FETCH_FORECASTS_SUCCESS:
    case EventsConstants.FETCH_FORECASTS_FAILURE:
    case TickersConstants.CREATE_TICKER_SUCCESS:      /**Tickes */
    case TickersConstants.CREATE_TICKER_FAILURE:
    case TickersConstants.GET_TICKER_SUCCESS:
    case TickersConstants.GET_TICKER_FAILURE:
    case EventsConstants.RENDER_SUCCESS:
    case AdminConstants.FETCH_REPORT_SUCCESS:          /** Admin */
        return {
            showLoading: false
        }
    default:
        return {
            ...state
        }
    }
}
